import { Stat } from "./stats";
import { Game } from "./types/GameTypes"


export const STATS_COOKIE_NAME = "cardleStats";

const GAME_NUMBER_AND_SCORE_SEPARATOR = ":";
const STAT_SEPARATOR = ";";

export const buildStat = (game: Game, gameNumber: number): Stat => {
  return {gameNumber, score: game.round};
}

export const parseStatsCookie = (statsCookieString: string): Stat[] => {
  const statParts = statsCookieString.split(STAT_SEPARATOR).filter(p => p.trim().length > 0);
  return statParts.map(parseStat);
}

const parseStat = (statString: string): Stat => {
  const [gameNumber, score] = statString.split(GAME_NUMBER_AND_SCORE_SEPARATOR);
  return { gameNumber: parseInt(gameNumber, 10), score: parseInt(score, 10)};
}

const writeStat = (stat: Stat): string => {
  return `${stat.gameNumber}${GAME_NUMBER_AND_SCORE_SEPARATOR}${stat.score}`;
}

// When merging, existing wins. You can't repeat a game and replace a bad score with a 
// better one
export const mergeIntoStatsCookieString = (existingStatsString: string, newStat: Stat):string => {
  let previousStats:Stat[] = parseStatsCookie(existingStatsString);

  const previousStatForThisGameNumber = previousStats.find(s => s.gameNumber === newStat.gameNumber);
  if (previousStatForThisGameNumber) {
    return previousStats.map(writeStat).join(STAT_SEPARATOR);
  } else {
    // New one. Good
    const newStats = [...previousStats, newStat];
    return newStats.map(writeStat).join(STAT_SEPARATOR);
  }
}